module.exports = {
  'zh-cn': require('./locale/zh-cn.js'),
};
